module.exports = __webpack_public_path__ + "img/Wiktoria.2b59d3b9.jpg";